

// Filename - App.js

import "./App.css";
import Sidebar from "./components/sidebar";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate
} from "react-router-dom";
import { Dashboard } from "./pages/Dashboard";
import { SerchTariff } from "./pages/SerchTariff";
import { BulkUpload } from "./pages/BulkUpload/BulkUpload";
import NewTariff from "./pages/NewTariff/NewTariff";
import Report from "./pages/Report";
import Login from "./pages/Login"
import PrivateRoute from "./pages/PrivateRoute";
import { useSelector } from "react-redux";
import MasterValue from "./pages/NewTariff/MasterValue";
import PaymentAdjustmentDetails from "./pages/CreditManagement/PaymentAdjustmentDetails";
import AdjustmentEntry from "./pages/CreditManagement/AdjustmentEntry";
import UsagesBalanceDetails from "./pages/CreditManagement/UsagesBalanceDetails";
import CreditManagement from "./pages/CreditManagement/CreditManagement";
import DisconnectionReconnectionDetaile from "./pages/ConnectionManagement/DisconnectionReconnectionDetaile"
import DisconnectionManagement from "./pages/ConnectionManagement/DisconnectionManagement"
import DisconnectionRequest from "./pages/ConnectionManagement/DisconnectionRequest"
import PendingDisconnectionDetails from "./pages/ConnectionManagement/PendingDisconnectionDetails"
import LowBalance from "./pages/Notification/LowBalance";
import Disconnection from "./pages/Notification/Disconnection";
import HighUsages from "./pages/Notification/HighUsages";
import NotificationRequestInput from "./pages/Notification/NotificationRequestInput";
import PaymentAndAdjustment from "./pages/Notification/PaymentAndAdjustment";
import Reconnection from "./pages/Notification/Reconnection";
import ViewNotificationDetails from "./pages/Notification/ViewNotificationDetails";

import MeterUsageDetails from "./pages/CreditManagement/MeterUsageDetails";


function App() {
    const { data, isLoading, error } = useSelector(state => state.loginReducer);
    const userData =  JSON.parse(localStorage.getItem("USER_DETAILS")); 
    return (
        <Router>
            <Routes>
                <Route
                    path="/"
                    element={<Login />}
                />
                <Route
                    path="/Dashboard"
                    element={<div><Sidebar /><div name="main"><Dashboard /></div></div>}
                />
                <Route
                    path="/SerchTariff"
                    element={<div><Sidebar /><div name="main"><SerchTariff /></div></div>}
                />
                <Route
                    path="/NewTariff"
                    element={<div><Sidebar /><div name="main"><NewTariff /></div></div>}
                />
                <Route
                    path="/NewTariff/MasterValue"
                    element={<div><Sidebar /><div name="main"><MasterValue userData={userData}/></div></div>}
                />
                <Route
                    path="/BulkUpload"
                    element={<div><Sidebar /><div name="main"><BulkUpload /></div></div>}
                />
                <Route
                    path="/Report"
                    element={<div><Sidebar /><div name="main"><Report /></div></div>}
                />

                <Route
                    path="/CreditManagement"
                    element={<div><Sidebar /><div name="main"><CreditManagement /></div></div>}
                />
                <Route
                    path="/AdjustmentEntry"
                    element={<div><Sidebar /><div name="main"><AdjustmentEntry /></div></div>}
                />
                <Route
                    path="/PaymentAdjustmentDetails"
                    element={<div><Sidebar /><div name="main"><PaymentAdjustmentDetails /></div></div>}
                />
                 <Route
                    path="/MeterUsageDetails"
                    element={<div><Sidebar /><div name="main"><MeterUsageDetails userData={userData}/></div></div>}
                />

                
                <Route
                    path="/UsagesBalanceDetails"
                    element={<div><Sidebar /><div name="main"><UsagesBalanceDetails /></div></div>}
                />
                <Route
                    path="/DisconnectionManagement"
                    element={<div><Sidebar /><div className="main_container" name="main"><DisconnectionManagement userData={userData} /></div></div>}
                />
                 <Route
                    path="/Disconnection-Re-connectionDetaile"
                    element={<div><Sidebar /><div name="main"><DisconnectionReconnectionDetaile userData={userData}  /></div></div>}
                />
                 <Route
                    path="/DisconnectionRequest"
                    element={<div><Sidebar /><div name="main"><DisconnectionRequest userData={userData}  /></div></div>}
                />
                 <Route
                    path="/PendingDisconnectionDetails"
                    element={<div><Sidebar /><div name="main"><PendingDisconnectionDetails  userData={userData}  /></div></div>}
                />
                 <Route
                    path="/low-balance"
                    element={<div><Sidebar /><div name="main"><LowBalance  userData={userData}  /></div></div>}
                />
                  <Route
                    path="/Disconnection"
                    element={<div><Sidebar /><div name="main"><Disconnection  userData={userData}  /></div></div>}
                />
                 <Route
                    path="/high-usages"
                    element={<div><Sidebar /><div name="main"><HighUsages  userData={userData}  /></div></div>}
                />
                <Route
                    path="/payment-and-adjustment"
                    element={<div><Sidebar /><div name="main"><PaymentAndAdjustment  userData={userData}  /></div></div>}
                />
                <Route
                    path="/Reconnection"
                    element={<div><Sidebar /><div name="main"><Reconnection  userData={userData}  /></div></div>}
                />
                <Route
                    path="/notification-request-input"
                    element={<div><Sidebar /><div name="main"><NotificationRequestInput  userData={userData}  /></div></div>}
                />
                  <Route
                    path="/view-notification-details"
                    element={<div><Sidebar /><div name="main"><ViewNotificationDetails  userData={userData}  /></div></div>}
                />

            </Routes>

        </Router>
    );
}

export default App;
